var defaultProps = {};
var styleOverrides = {
  root: function root(_ref) {
    var theme = _ref.theme;
    return {
      '& .MuiLink-root': {
        color: theme.palette.primary.main
      },
      '& .LumaContainerPatientFormLaunch-root': {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0, 4)
      }
    };
  }
};
export default {
  defaultProps: defaultProps,
  styleOverrides: styleOverrides
};